import {
  Button,
  Col,
  Drawer,
  Form,
  Input,
  message,
  Modal,
  Row,
  Select,
  Space,
  Table,
  Tag,
} from "antd";
import { useDropzone } from "react-dropzone";

import axios from "axios";
import React, { createRef, useEffect, useState } from "react";
import { PlusCircle } from "react-feather";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import { CardBody } from "reactstrap";
import styled from "styled-components";
import { H5 } from "../../../../AbstractElements";
import {
  BulkUploadItemApi,
  OrganisationBranchApi,
  OrganisationUsers,
} from "../../../../api";
import { fetchUserPermissions } from "../../../../api/user.api";
import { organisationEditGranted } from "../../../../utils/PermissionFunctions/userPermissions";
import UploadResultTable from "../../Project/Budget/uploadResultTable";

const ContainerUpload = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  border-width: 2px;
  border-radius: 2px;
  border-color: #e8e8e8;
  border-style: dashed;
  background-color: #fafafa;
  color: #bdbdbd;
  outline: none;
  transition: border 0.24s ease-in-out;
`;

export function StyledDropzone(props) {
  const {
    acceptedFiles,
    getRootProps,
    getInputProps,
    isDragActive,
    isDragAccept,
    isDragReject,
  } = useDropzone();
  useEffect(() => {
    if (acceptedFiles.length > 0) props.setFile(acceptedFiles[0]);
  }, [acceptedFiles]);
  const files = acceptedFiles.map((file) => (
    <li key={file.path}>
      {file.path} - {file.size} bytes
    </li>
  ));
  return (
    <div className="container">
      <ContainerUpload
        {...getRootProps({ isDragActive, isDragAccept, isDragReject })}
      >
        <input {...getInputProps()} />
        <div style={{ height: 120 }}>
          <p style={{ marginTop: 40, textAlign: "center" }}>
            Bulk Upload files.
            <br /> Drag and drop your file here, or click to select.
          </p>
        </div>
      </ContainerUpload>
    </div>
  );
}
const mapStateToProps = ({ dispatch, settings }) => ({
  dispatch,
  settings,
});
const Members = (props) => {
  const formRef = createRef();
  const { Option } = Select;
  const [memberList, setMemberList] = useState([]);
  const [branches, setBranches] = useState([]);
  const [permissions, setPermissions] = useState([]);
  const [modal1Visible, setModal1Visible] = useState(false);
  const [modal3Visible, setModal3Visible] = useState(false);
  const [excelData, setExcelData] = useState([]);
  const [isAddTrue, setisAddTrue] = useState(true);
  const [selectedUser, setSelectedUser] = useState(null);

  const { user } = props.settings;
  useEffect(() => {
    fetchMemberList();
    fetchBranches();
    fetchUserPermissions().then((result) => {
      setPermissions(result);
    });
  }, []);

  const fetchMemberList = () => {
    axios.get(`${OrganisationUsers}`).then((res) => {
      setMemberList(res.data);
    });
  };

  function uploadData(e) {
    var items = e;
    const formValue = new FormData();
    // formValue.append("project", props.settings.project.id);
    formValue.append("file", items, items.name);
    axios
      .post(`${BulkUploadItemApi}`, formValue)
      .then((res) => {
        toast.success("Items added successfully!");
        setModal1Visible(false);
        setExcelData(res.data?.excel_data);
      })
      .catch((res) => {
        toast.error(res.message);
      });
  }

  const fetchBranches = () => {
    const { dispatch } = props;
    axios.get(`${OrganisationBranchApi}`).then((res) => {
      setBranches(res?.data);
      dispatch({
        type: "settings/CHANGE_SETTING",
        payload: {
          setting: "all_branches",
          value: res?.data,
        },
      });
    });
  };

  const addMember = (values) => {
    console.log(values);
    if (
      !/^\d{10}$/.test(values.contact) ||
      !/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(values.email) ||
      values.name.length == 0
    ) {
      message.error("Enter details correctly");
      return;
    } else {
      const payload = new FormData();
      payload.append("name", values.name);
      payload.append("contact", values.contact);
      payload.append("organisation", user?.organisation?.organisation_id);
      payload.append("email", values.email);
      // payload.append("branch", values.branch);
      payload.append(
        "designation",
        values.designation ? values.designation : ""
      );
      payload.append("user_permission", values.user_permission);
      payload.append("department", values.department ? values.department : "");
      console.log("branch", JSON.stringify(values?.branch));
      // payload.append(
      //   "branch",
      //   values.branch ? JSON.stringify(values.branch) : JSON.stringify([])
      // );

      values?.branch?.map((b) => {
        payload.append("branch", b);
      });

      axios
        .post("apiV1/user-organisation/", payload)
        .then((res) => {
          console.log("Member added", res);
          message.success("New member added succesfully");
          fetchMemberList();

          setModal1Visible(false);
          formRef.current.resetFields([
            "name",
            "contact",
            "email",
            "designation",
            "department",
          ]);
        })
        .catch((e) => {
          if (e?.response?.status == 400) {
            message.error("User already added to a organisation.");
          }
        });
    }
  };

  const editMember = (values) => {
    console.log(values);
    const payload = new FormData();
    payload.append("user_permission", values.user_permission);
    // payload.append("contact", values.contact);
    // payload.append("organisation", user?.organisation?.organisation_id);
    // payload.append("email", values.email);
    // payload.append(
    //   "designation",
    //   values.designation ? values.designation : ""
    // );
    // payload.append("department", values.department ? values.department : "");

    values?.branch?.map((b) => {
      payload.append("branch", b);
    });

    axios
      .put("apiV1/user-organisation/" + selectedUser?.id + "/", payload)
      .then((res) => {
        console.log("Member added", res);
        message.success("Member edited succesfully");
        fetchMemberList();
        setModal1Visible(false);
        formRef.current.resetFields();
      });
  };
  const columns = [
    {
      title: "Name",
      key: "name",
      render: (data) => <span>{data?.user?.name}</span>,
    },
    {
      title: "Designation",
      key: "designation",
      render: (data) => <span>{data?.user?.designation}</span>,
    },
    {
      title: "Phone Number",
      key: "phone",
      render: (data) => <span>{data?.user?.contact}</span>,
    },
    {
      title: "Department",
      key: "department",
      render: (data) => <span>{data?.user?.department}</span>,
    },
    {
      title: "Email",
      key: "email",
      render: (data) => <span>{data?.user?.email}</span>,
    },
    {
      title: "Actions",
      key: "actions",
      render: (data) => (
        <Space>
          <Tag
            color="purple"
            style={{ cursor: "pointer" }}
            onClick={() => {
              // setSelectedMember(data);
              if (organisationEditGranted(props.settings?.user)) {
                setModal1Visible(true);
                setisAddTrue(false);
                const userData = data?.user;
                setSelectedUser(data);
                formRef.current.setFieldsValue({
                  name: userData?.name,
                  contact: userData?.contact,
                  email: userData?.email,
                  designation: userData?.designation,
                  user_permission: data?.user_permission,
                  department: userData?.department,
                  branch: data?.branch?.map((b) => b.id),
                });
              } else {
                toast.info(
                  "You do not have the access to perform this action."
                );
              }
            }}
          >
            Edit Details
          </Tag>
          {/* <Tag color="error">Delete</Tag> */}
        </Space>
      ),
    },
  ];

  const viewColumns = [
    {
      title: "Name",
      key: "name",
      render: (data) => <span>{data?.user?.name}</span>,
    },
    {
      title: "Designation",
      key: "designation",
      render: (data) => <span>{data?.user?.designation}</span>,
    },
    {
      title: "Phone Number",
      key: "phone",
      render: (data) => <span>{data?.user?.contact}</span>,
    },
    {
      title: "Department",
      key: "department",
      render: (data) => <span>{data?.user?.department}</span>,
    },
    {
      title: "Email",
      key: "email",
      render: (data) => <span>{data?.user?.email}</span>,
    },
  ];

  return (
    <React.Fragment>
      <CardBody>
        <div className="d-flex justify-content-between align-items-center">
          <div className="">
            <H5>Member List</H5>
          </div>
          <Space>
            {organisationEditGranted(props.settings?.user) && (
              <Button
                className="btn btn-primary d-flex align-items-center"
                style={{ color: "white", margin: 8 }}
                onClick={() => {
                  if (organisationEditGranted(props.settings?.user)) {
                    setModal1Visible(true);
                    setisAddTrue(true);
                  } else {
                    toast.info(
                      "You do not have the access to perform this action."
                    );
                  }
                }}
              >
                {" "}
                <PlusCircle />
                <div style={{ marginLeft: "4px" }}>Add Member</div>
              </Button>
            )}
            <Input.Search
              placeholder="Search by phone number"
              onSearch={(value) => {
                if (value) {
                  setMemberList(
                    memberList.filter((each) =>
                      String(each?.user?.contact).includes(value)
                    )
                  );
                } else {
                  fetchMemberList();
                }
              }}
              allowClear
            />
          </Space>
        </div>

        <Table
          columns={
            organisationEditGranted(props.settings?.user) ? columns : columns
          }
          dataSource={memberList}
          scroll={{ x: "max-content" }}
        />
      </CardBody>
      <Drawer
        title={isAddTrue ? "Add Member" : "Edit member"}
        centered
        width={500}
        forceRender={true}
        placement="right"
        visible={modal1Visible}
        onClose={() => {
          formRef.current.resetFields();
          setModal1Visible(false);
        }}
        footer={[
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            {" "}
            <Button
              style={{ marginRight: 8 }}
              key="back"
              onClick={() => {
                formRef.current.resetFields();
                setModal1Visible(false);
              }}
            >
              Cancel
            </Button>
            {user.contact == "9833291910" && (
              <Button
                style={{ marginRight: 8 }}
                key="back"
                onClick={() => {
                  const values = new FormData();
                  values.append("is_active", false);
                  const config = {
                    headers: {
                      "content-type": "multipart/form-data",
                    },
                  };
                  axios
                    .put(
                      `apiV1/user/${selectedUser?.user?.id}/`,
                      values,
                      config
                    )
                    .then((res) => {
                      toast.success("Successfully edited details");
                      formRef.current.resetFields();
                      setModal1Visible(false);
                    })
                    .catch((error) => {
                      toast.error(
                        "Could not edit  profile details. Please try again"
                      );
                      formRef.current.resetFields();
                      setModal1Visible(false);
                    });
                }}
              >
                Delete User
              </Button>
            )}
            <Button
              key="submit"
              className="btn btn-primary text-white"
              htmlType="submit"
              // loading={loading}
              form="memberForm"
              // onClick={() => {
              //   addStep();
              // }}
            >
              Submit
            </Button>
          </div>,
        ]}
      >
        <Form
          layout="vertical"
          id="memberForm"
          ref={formRef}
          onFinish={isAddTrue ? addMember : editMember}
        >
          {isAddTrue && (
            <>
              <Row gutter={24}>
                <Col sm={12}>
                  <Form.Item
                    name={"name"}
                    label="Name"
                    rules={[
                      {
                        required: true,
                      },
                    ]}
                  >
                    <Input className="w-100" placeholder="Name" />
                  </Form.Item>
                </Col>
                <Col sm={12}>
                  <Form.Item
                    name={"email"}
                    label="Email"
                    rules={[
                      {
                        required: true,

                        pattern:
                          /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/,
                        message: "Enter a valid Email",
                      },
                    ]}
                  >
                    <Input className="w-100" placeholder="Email" />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={24}>
                <Col sm={12}>
                  <Form.Item
                    name={"contact"}
                    label="Phone Number"
                    rules={[
                      {
                        required: true,

                        pattern: /^\d{10}$/,
                        message: "Phone Number is required",
                      },
                    ]}
                  >
                    <Input
                      type="number"
                      className="w-100"
                      placeholder="Contact"
                      onInput={(e) =>
                        (e.target.value = e.target.value.slice(0, 10))
                      }
                    />
                  </Form.Item>
                </Col>
                <Col sm={12}>
                  <Form.Item
                    name={"department"}
                    label="Department"
                    rules={[
                      {
                        pattern: /^[A-Za-z]+[A-Za-z ]*$/,
                        message: "Enter valid Department",
                      },
                    ]}
                  >
                    <Input className="w-100" placeholder="Department" />
                  </Form.Item>
                </Col>
              </Row>
            </>
          )}

          <Row gutter={24}>
            {isAddTrue && (
              <Col sm={12}>
                <Form.Item
                  name={"designation"}
                  label="Designation"
                  rules={[
                    {
                      pattern: /^[A-Za-z]+[A-Za-z ]*$/,
                      message: "Enter valid Designation",
                    },
                  ]}
                >
                  <Input className="w-100" placeholder="Designation" />
                </Form.Item>
              </Col>
            )}
            <Col sm={12}>
              <Form.Item name={"branch"} label="Branch">
                <Select
                  size="large"
                  mode="multiple"
                  placeholder="Select branch"
                >
                  {branches?.map((each, index) => (
                    <Option key={index} value={each?.id}>
                      {each?.branch_name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={24}>
            <Col sm={12}>
              <Form.Item name={"user_permission"} label="Permission">
                <Select size="large" placeholder="Select permission">
                  {permissions?.map((each, index) => (
                    <Option key={index} value={each?.id}>
                      {each?.permission_name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Drawer>

      <Modal
        title="Bulk Upload Result"
        centered
        visible={modal3Visible}
        width="600px"
        onCancel={() => {
          setModal3Visible(false);
        }}
        footer={null}
      >
        <UploadResultTable data={excelData} />
      </Modal>
    </React.Fragment>
  );
};

export default connect(mapStateToProps)(Members);
